import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2fbeca3d")

_pushScopeId("data-v-2fbeca3d")
const _hoisted_1 = { class: "view-card" }
const _hoisted_2 = {
  key: 0,
  class: "view-card__header"
}
const _hoisted_3 = { class: "view-card__header__top" }
const _hoisted_4 = { class: "status" }
const _hoisted_5 = { class: "insertDate -notosans" }
const _hoisted_6 = {
  key: 0,
  class: "view-card__header__mid"
}
const _hoisted_7 = { class: "list-item-detail" }
const _hoisted_8 = { class: "-medium" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { class: "value" }
const _hoisted_11 = { class: "-medium" }
const _hoisted_12 = { class: "label" }
const _hoisted_13 = { class: "value" }
const _hoisted_14 = {
  key: 0,
  class: "-medium -pc"
}
const _hoisted_15 = { class: "label -notosans" }
const _hoisted_16 = { class: "value" }
const _hoisted_17 = {
  key: 0,
  class: "-medium -mobile scheduled-date"
}
const _hoisted_18 = { class: "label" }
const _hoisted_19 = { class: "value -notosans" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RequestProgress = _resolveComponent("RequestProgress")
  const _component_RequestProgressDesc = _resolveComponent("RequestProgressDesc")
  const _component_DoctorItem = _resolveComponent("DoctorItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (!_ctx.state.isLoading)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_RequestProgress, { cardInfo: _ctx.cardInfo }, null, 8, ["cardInfo"]),
              _createVNode(_component_RequestProgressDesc, {
                cardInfo: _ctx.cardInfo,
                class: "-pc"
              }, null, 8, ["cardInfo"])
            ]),
            _createVNode("span", _hoisted_5, _toDisplayString(_ctx.insertDateTime), 1)
          ]),
          (!!_ctx.state.item)
            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode(_component_DoctorItem, {
                  doctor: _ctx.state.item,
                  isDefaultDetail: false
                }, {
                  detail: _withId(() => [
                    _createVNode("div", _hoisted_7, [
                      _createVNode("ul", null, [
                        _createVNode("li", _hoisted_8, [
                          _createVNode("span", _hoisted_9, _toDisplayString(_ctx.state.item.DeptName), 1),
                          _createVNode("span", _hoisted_10, _toDisplayString(_ctx.state.item.DoctorName), 1)
                        ]),
                        _createVNode("li", _hoisted_11, [
                          _createVNode("span", _hoisted_12, _toDisplayString(_ctx.t('request kind')), 1),
                          _createVNode("span", _hoisted_13, _toDisplayString(_ctx.state.kind), 1)
                        ]),
                        (_ctx.state.kind === _ctx.RequestKindTypes.OnlineCare)
                          ? (_openBlock(), _createBlock("li", _hoisted_14, [
                              _createVNode("span", _hoisted_15, _toDisplayString(_ctx.t('reserved date/time')), 1),
                              _createVNode("span", _hoisted_16, _toDisplayString(_ctx.scheduledDate), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["doctor"]),
                (_ctx.state.kind === _ctx.RequestKindTypes.OnlineCare)
                  ? (_openBlock(), _createBlock("div", _hoisted_17, [
                      _createVNode("div", null, [
                        _createVNode("span", _hoisted_18, _toDisplayString(_ctx.t('scheduled date/time')), 1),
                        _createVNode("span", _hoisted_19, _toDisplayString(_ctx.scheduledDate), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
})